import React, { useState, useContext } from 'react';
import Link from './components/Link/index.js';
import { S as SubMenu } from './SubMenu-3IxuijNo.js';
import { U as UrlType } from './menu-0TyOg98i.js';
import { CoreContext } from './context/index.js';
import './utils/logToSlack.js';
import './animations--PMkOS0j.js';
import 'cookies-next';
import './currency-_kacFJHO.js';
import './language-BHHwgtQp.js';
import './payment-YC9H491Y.js';
import './index-sNwiaBfD.js';
import 'next/router';
import useHoverIntent from './hooks/useHoverIntent.js';
import useOutsideFocus from './hooks/useOutsideFocus.js';
import 'notistack';
import 'next-i18next';
import 'lodash/get';
import './product-_pRduMz7.js';
import './helpers-kA_hdoOI.js';
import 'lodash';
import { useTranslation } from 'react-i18next';
import { dataLabelFormat } from './utils/userClickHandler.js';

const MenuItem = ({ item, position, active, onFocus }) => {
    const [isFocus, setIsFocus] = useState(false);
    const { data: { locale, siteConfig: { header: { hideSubmenus = false, menuItemHoverInDelay = 150, menuItemHoverOutDelay = 400, } = {}, }, }, } = useContext(CoreContext);
    const title = item.localized_menu_item_title || item.original_title;
    const dataLabel = dataLabelFormat(title);
    const [isHovering, intentRef] = useHoverIntent({
        inDelay: menuItemHoverInDelay,
        outDelay: menuItemHoverOutDelay,
        onHoverCallback: () => {
            onFocus(dataLabel);
        },
    });
    const outsideFocus = useOutsideFocus(() => {
        setIsFocus(false);
    });
    const { t: tCustomLink } = useTranslation('', { keyPrefix: '$local.$scandiwebCustomLinks' });
    const handleClick = (event) => {
        if (!event.ctrlKey && !event.metaKey && !event.shiftKey && event.button === 0) {
            // If the link is not opened in a new tab, set SubMenu as not visible
            setIsFocus(false);
        }
    };
    const href = () => {
        if (item.url_type === 0) {
            const customUrl = item.url.replace('/', '') || null;
            return `/${locale}/${tCustomLink(customUrl)}`;
        }
        return `/${locale}${item.url}`;
    };
    // Optionally add a hover item to the menu for product types in the nav bar.
    const finalItems = item.url_type === UrlType.Product && item.icon ? [item] : item.children;
    if (!title)
        return null;
    return (React.createElement("li", { ref: el => {
            intentRef.current = el;
            outsideFocus.current = el;
        }, onFocus: () => {
            setIsFocus(true);
        }, className: item.item_class || null },
        React.createElement(Link, { className: "nav-menu-item", href: href(), noUnderline: true, onClick: handleClick, "data-event-name": "menu_interact", "data-menu-label": dataLabel, "data-menu-position": position }, title),
        !hideSubmenus && (React.createElement(SubMenu, { items: finalItems, extras: item.extras, visible: (!!isHovering || isFocus) && active === dataLabel, onClick: handleClick, dataParentName: dataLabel }))));
};

export { MenuItem as M };
//# sourceMappingURL=MenuItem-Dn2z2gAG.js.map
